<template>
  <div style="height: 100%;">
    测试system-login

  </div>
</template>
<script type="text/ecmascript-6">

export default {
  name: "login",
  components: {
  },
  data() {
    return {
     
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    if (window.location.href.indexOf('client_id=') > -1) {
            this.client_id = window.location.href.split("client_id=")[1];
            this.client_id=this.client_id.split('&')[0];
            this.redirect_uri = window.location.href.split("redirect_uri=")[1];
            this.redirect_uri=this.redirect_uri.split('&')[0];    
    }
    if (window.location.href.indexOf('redirect=') > -1) {
            this.redirect = window.location.href.split("redirect=")[1];
    }
  },

  // 里面的函数只有调用才会执行
  
};
</script>



// WEBPACK FOOTER //
// src/views/systemLogin.vue